export default "__VITE_ASSET__43a75654__"